// extracted by mini-css-extract-plugin
export default {"menuItemShortcutText":"menuItemShortcutText_GkN0q","shortCutPlaceholder":"shortCutPlaceholder_pB34G","height100":"height100_yaDl3","isMoreOverageItems":"isMoreOverageItems_FwPAO"};